import Table from 'components/UIKit/Table';
import ErrorSummaryColumns from './ErrorSummaryColumns';
import ErrorSummaryRows from './ErrorSummaryRows';

type ErrorSummaryTableProps = {
  router: Object,
  children: any
}

export default function ErrorSummaryTable({
  children,
  router,
}: ErrorSummaryTableProps): React.Element {
  return (
    <Table>
      <ErrorSummaryColumns />
      <ErrorSummaryRows router={router}>
        {children}
      </ErrorSummaryRows>
    </Table>
  );
}
